import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { clsx } from "../../../../clsx/dist/clsx.es.js";
import { styled } from "@mui/system";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const _excluded = ["className"];
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["iconButtonContainer"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridIconButtonContainerRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "IconButtonContainer",
  overridesResolver: (props, styles) => styles.iconButtonContainer
})(() => ({
  display: "flex",
  visibility: "hidden",
  width: 0
}));
const GridIconButtonContainer = /* @__PURE__ */ React.forwardRef(function GridIconButtonContainer2(props, ref) {
  const {
    className
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridIconButtonContainerRoot, _extends({
    ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});
export {
  GridIconButtonContainer
};
//# sourceMappingURL=GridIconButtonContainer.es.js.map
